import LogisticsPageHero from '../Logistics/LogisticsPageHero';

const FBM_HERO_IMAGE =
  '/fulfilmentbymerchant/fbmhero.webp';

const FBMHero = () => (
  <LogisticsPageHero
    ariaLabel="Amazon FBM fulfilment UK"
    imageSrc={FBM_HERO_IMAGE}
    imageAlt="Amazon FBM fulfilment UK warehouse - Expert Fulfilment by Merchant services for Amazon sellers"
    titleLight="Amazon FBM Fulfilment UK"
    titleAccent="Expert Fulfilment by Merchant Services"
    description={
      <>
        <p>
          Scale your business with Amazon FBM Fulfilment UK from Pick Pack Pro. Our Fulfilment by Merchant (FBM)
          services help UK ecommerce sellers manage Amazon orders with fast dispatch, accurate pick-and-pack
          fulfilment, secure warehousing, and fully tracked nationwide delivery.
        </p>
        <p>
          Operating from our Milton Keynes fulfilment centre, we provide reliable Amazon FBM fulfilment, inventory
          management, and multi-channel order processing — with transparent pricing and dedicated account support.
        </p>
      </>
    }
    features={[
      'Picking Fees from £0.99',
      'Next-Day Shipping from £1.99',
      '99.9% Order Accuracy',
      'Dedicated Account Manager',
      'Price Match Promise',
    ]}
    primaryCta={{ label: 'Get a free quote', to: '/contact-fulfillment-services' }}
  />
);

export default FBMHero;
